export const hoverToggle = () => ({
	type: 'HOVER_TOGGLE',
})

export const unhoverToggle = () => ({
	type: 'UNHOVER_TOGGLE',
})
